<!-- Desktop Carousel -->
@if(crossFadeData){
<owl-carousel-o class="carousel-pc" [options]="crossFadeOptions">
  @for (slideData of crossFadeData; track slideData) {
  <ng-template carouselSlide>
    <div class="carousel-item">
      <img class="d-block w-100" [src]="slideData.img" alt="banner" />
    </div>
  </ng-template>
  }
</owl-carousel-o>
}
<!-- Mobile Carousel -->
<!-- <owl-carousel-o class="carousel-movile" [options]="crossFadeOptions">
    @for (slideData of crossFadeDataMobile; track slideData) {
      <ng-template carouselSlide>
        <div class="carousel-item">
          <img class="d-block w-100" [src]="slideData.img" alt="banner" />
        </div>
      </ng-template>
    }
  </owl-carousel-o>
   -->